export { renderBadge_unstable as renderBadge } from '@fluentui/react-badge';
